import { render, staticRenderFns } from "./CodPostalesCard.vue?vue&type=template&id=783a0290&scoped=true&"
import script from "./CodPostalesCard.vue?vue&type=script&lang=js&"
export * from "./CodPostalesCard.vue?vue&type=script&lang=js&"
import style0 from "./CodPostalesCard.vue?vue&type=style&index=0&id=783a0290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783a0290",
  null
  
)

export default component.exports